import { connect } from 'react-redux'
import WebcamScreen from './WebcamScreen'
import selectPresenterHidden from '../../dataStore/selectors/selectPresenterHidden'
import selectEnabledVideoTracksForPresenter from '../../dataStore/selectors/selectEnabledVideoTracksForPresenter'
import { State } from '../../dataStore/reducers/reducerType'
import { WebcamScreenProps } from './types'
import roles from '../../dataStore/constants/roles'
import selectPresenterMuted from '../../dataStore/selectors/selectPresenterMuted'


const makeMapStateToProps = () => {

  const getPresenterHidden = selectPresenterHidden()
  const getPresenterMuted = selectPresenterMuted()


  const mapStateToProps = (state: State, props: Pick<WebcamScreenProps, 'presenter'>): Omit<WebcamScreenProps, 'size' | 'inSidebar'> => ({
    presenter: props.presenter,
    isHidden: getPresenterHidden(state, props),
    isMuted: getPresenterMuted(state, { presenter: { BTID: props.presenter.BTID }, ignoreRoom: true }),
    enabledVideoTracks: selectEnabledVideoTracksForPresenter(state, { presenter: props.presenter }),
    isOverlayDisabled: state.config.role === roles.WATCH,
    isBridgeInstance: state.config.bridgeName !== ''
  })

  return mapStateToProps

}

export default connect(makeMapStateToProps)(WebcamScreen)
